import { Route, Routes as ReactRouterRoutes } from 'react-router-dom';

import { NewsIndexContainer } from 'hb-react/frontoffice/apps/NewsIndex/containers/NewsIndexContainer';
import type { Config } from 'hb-react/frontoffice/apps/NewsIndex/types';
import NewsPublished from 'hb-react/shared/apps/News/NewsPublished';

export const NewsIndexClient = ({
  config,
  topic,
}: {
  config: Config;
  topic?: any;
}) => (
  <ReactRouterRoutes>
    <Route
      index
      element={<NewsIndexContainer config={config} topic={topic} />}
    />
    <Route
      path=":newsId"
      element={<NewsPublished config={config} topic={topic} />}
    />
  </ReactRouterRoutes>
);

export default NewsIndexClient;
